module.exports = __webpack_public_path__ + "assets/img/information_icon.11437c80.svg";